import { GET, POST } from "@/api/client";
import { TResponse } from "@/api/types";
import { useMutation, useQuery } from "@tanstack/react-query";
import { TransferPatientStatusResponse } from "../types";
import { queryClient } from "@/api/query";
import { useNavigate } from "react-router";

export const useGetPatientStatus = (requestId: string) => {
  return useQuery<TResponse<TransferPatientStatusResponse>>({
    queryKey: [`/transfer/requests/${requestId}/patients`],
    queryFn: () => GET(`/transfer/requests/${requestId}/patients`),
  });
};

export const usePostRuquestDecision = (requestId: string) => {
  return useMutation({
    mutationFn: async (
      data:
        | {
            requestStatus: "accepted";
          }
        | {
            requestStatus: "rejected";
            rejectReason: string;
          }
    ) => {
      const response = await POST(
        `/transfer/requests/${requestId}/decision?hospitalCode=A1300002`,
        data
      );
      return response;
    },
    onSuccess(data) {
      queryClient.invalidateQueries({
        queryKey: [`/transfer/requests/${requestId}/patients`],
      });
      queryClient.invalidateQueries({
        queryKey: [`/transfer/requests/${requestId}/info`],
      });
      queryClient.invalidateQueries({
        queryKey: [`/transfer/requests`],
      });
      queryClient.invalidateQueries({
        queryKey: [`/transfer/requests/transferring`],
      });
    },
  });
};
